import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curve-shape-right",
  "use": "icon-curve-shape-right-usage",
  "viewBox": "0 0 770.73 98.76",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 770.73 98.76\" preserveAspectRatio=\"none\" id=\"icon-curve-shape-right\"><path d=\"M0 70.91c109.64 11.86 218.63-2.7 221.85-3.14a920.17 920.17 0 0 1-183.12 19q-20.3 0-38.74-1zm770.73-55.49V2.78C583.46-8.44 442.53 15.06 295.49 58.39 139.82 104.27 6.3 95.59 6.3 95.59l-6.3-.2v3.36h770.73V31.06c-133.39-21.92-309.86-2.2-309.86-2.2C597.22 4.31 711.68 8.82 770.73 15.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol